// HOOKS
import { useContext } from "react";
import { ProductsContext } from "../../../contexts/products/products.context";
// CONSTANTS
import { CATEGORIES } from "../../../constants/forms/product/categories.product.form.constant";
const PRODUCT = {
  _id: "",
  name: "",
  make: "",
  model: "",
  category: "",
  external_description: "",
  repairShopr_id: "",
  retail_price: "",
  created_at: "",
  updated_at: "",
  tags: [],
};

const CHANGE_HANDLERS = {
  handleChange: () => {},
};

const GetProductFormProps = ({
  formObject = PRODUCT,
  changeHandlers = CHANGE_HANDLERS,
}) => {
  const {
    _id,
    name,
    make,
    model,
    category,
    external_description,
    repairShopr_id,
    retail_price,
    created_at,
    updated_at,
    tags,
  } = formObject;
  const { handleChange } = changeHandlers;
  return {
    make: {
      type: "text",
      props: {
        "data-id": _id,
        label: "Make",
        value: make,
        name: "make",
        onChange: handleChange,
        className: "w-96",
      },
    },
    model: {
      type: "text",
      props: {
        "data-id": _id,
        label: "Model",
        value: model,
        name: "model",
        onChange: handleChange,
        className: "w-96",
      },
    },
    category: {
      type: "selection",
      props: {
        "data-id": _id,
        label: "Category",
        value: category,
        name: "category",
        options: CATEGORIES,
        onChange: handleChange,
        className: "w-96",
      },
    },
    external_description: {
      type: "text",
      props: {
        "data-id": _id,
        label: "External Description",
        value: external_description,
        name: "external_description",
        onChange: handleChange,
        className: "w-96",
      },
    },
    repairShopr_id: {
      type: "number",
      props: {
        "data-id": _id,
        label: "RepairShopr ID",
        value: repairShopr_id,
        name: "repairShopr_id",
        onChange: handleChange,
        className: "w-96",
      },
    },
    retail_price: {
      type: "number",
      props: {
        "data-id": _id,
        step: "0.01",
        label: "Retail Price",
        value: retail_price,
        name: "retail_price",
        onChange: handleChange,
        className: "w-96",
      },
    },
    created_at: {
      type: "date",
      props: {
        "data-id": _id,
        label: "Created At",
        value: created_at,
        name: "created_at",
        onChange: handleChange,
        className: "w-96",
      },
    },
    updated_at: {
      type: "date",
      props: {
        "data-id": _id,
        label: "Updated At",
        value: updated_at,
        name: "updated_at",
        onChange: handleChange,
        className: "w-96",
      },
    },
    tags: {
      type: "text",
      props: {
        "data-id": _id,
        label: "Tags",
        value: tags,
        name: "tags",
        onChange: handleChange,
        className: "w-96",
      },
    },
    name: {
      type: "text",
      props: {
        "data-id": _id,
        label: "Name",
        value: name,
        name: "name",
        onChange: handleChange,
        className: "w-96",
      },
    },
  };
};

export default GetProductFormProps;
